// extracted by mini-css-extract-plugin
module.exports = {"title":"GuideIcon_title_2Q4F-","info_content":"GuideIcon_info_content_VybKi","no_transform":"GuideIcon_no_transform_1PxdP"};